module.exports = __webpack_public_path__ + "img/na.2ad28a94.png";